
import Logger from "../shared/logger";
const LOGGER = new Logger(__filename);

export const UNKNOWN = "UNKNOWN";
export const ONLINE_EDITOR = "online-editor";
export const LS_INFO = "ls-info";

const unknownHandler = {
    createUrl(/* { path, _part } */) {
        return "#";
    },
    cssClass: "fa fa-lg fa-question",
    description: "Unbekannte Aktion"

};

/**
 * Mappt eine actionAPI auf die Ziel-URL. 
 * 
 * createUrl() wird das element des FileSystems übergeben: {_owner="jsteuer", path="a/b/xxx.ls", _part="vfs"}
 */
const handlers = {
    // Unbekannte Aktion:
    [UNKNOWN]: unknownHandler,
    // Echte Actions:
    [ONLINE_EDITOR]: {
        createUrl({ path, _part }) {
            return `online-editor.html?path=${path}&part=${_part}`;
        },
        cssClass: "fa fa-lg fa-edit",
        description: "Öffnet den Online-Editor für diese Datei"
    },
    [LS_INFO]: {
        createUrl({ path, _part }) {
            return `ls-info.html?part=${_part}&path=${path}`;
        },
        cssClass: "fa fa-lg fa-info",
        description: "Zeigt in die Datei eingebettete LSInfo-Informationen an"
    },
};

export default {
    getHandler(actionIdentifier) {
        if (actionIdentifier) {
            const handler = handlers[actionIdentifier];
            if (handler) {
                return handler;
            } else {
                LOGGER.error(`no handler for identifier ${actionIdentifier} found`);
            }
        }
        return unknownHandler;
    }
};

